import { DataSource, Layout, LayoutHeader, Panel, Repeater } from "@mcleod/components";

export abstract class AutogenLayoutIntegrationHub extends Layout {
    layoutheaderIntegrationDashboard: LayoutHeader;
    panelIntegrationsContainer: Panel;
    repeater: Repeater;
    sourceIntegrationPartnerList: DataSource;
}
